import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calculator } from "lucide-react";
import { Slider } from "../ui/slider";
import { sipSeries } from "../../lib/calc";
import { inrCompact } from "../../lib/format";
import { SectionHead } from "../common/Section";

const TOOLS = ["SIP Calculator", "Mutual Fund Returns", "Compound Interest", "Retirement Planning", "Insurance Coverage", "Goal-Based Investment", "Risk Profile Assessment"];

function MiniSip() {
  const [amt, setAmt] = useState(10000);
  const [yrs, setYrs] = useState(15);
  const r = sipSeries(amt, 12, yrs);
  return (
    <div data-testid="mini-sip-widget" className="glass-dark rounded-3xl p-8">
      <div className="flex items-center justify-between text-sm text-slate-400"><span>Monthly SIP</span><span className="font-num text-white">₹{amt.toLocaleString("en-IN")}</span></div>
      <Slider className="mt-4" min={500} max={100000} step={500} value={[amt]} onValueChange={([v]) => setAmt(v)} data-testid="mini-sip-amount-slider" />
      <div className="mt-8 flex items-center justify-between text-sm text-slate-400"><span>Duration</span><span className="font-num text-white">{yrs} years</span></div>
      <Slider className="mt-4" min={1} max={40} step={1} value={[yrs]} onValueChange={([v]) => setYrs(v)} data-testid="mini-sip-years-slider" />
      <div className="mt-10 grid grid-cols-2 gap-4 border-t border-white/10 pt-6">
        <div><p className="text-xs uppercase tracking-wider text-slate-500">Invested</p><p className="font-num mt-1 text-2xl text-white" data-testid="mini-sip-invested">{inrCompact(r.invested)}</p></div>
        <div><p className="text-xs uppercase tracking-wider text-slate-500">Illustrative value @12%</p><p className="font-num mt-1 text-2xl text-mint" data-testid="mini-sip-value">{inrCompact(r.value)}</p></div>
      </div>
      <p className="mt-6 text-xs text-slate-500">Illustrative projection at an assumed 12% p.a. Not a guaranteed return.</p>
    </div>
  );
}

export default function ToolsSection() {
  return (
    <section data-testid="tools-section" className="relative overflow-hidden bg-navy py-24 lg:py-32">
      <div className="grid-lines absolute inset-0" />
      <div className="container-q relative grid items-center gap-16 lg:grid-cols-2">
        <div>
          <SectionHead dark eyebrow="Smart Financial Tools" title="Run the numbers before you decide." text="Seven interactive calculators to help you understand SIPs, compounding, retirement, protection and your own risk profile." />
          <ul className="mt-10 grid gap-3 sm:grid-cols-2">
            {TOOLS.map((t) => <li key={t} className="flex items-center gap-3 text-sm text-slate-300"><Calculator size={15} className="text-gold" />{t}</li>)}
          </ul>
          <Link to="/calculators" data-testid="tools-open-calculators-btn" className="group mt-10 inline-flex items-center gap-2 rounded-full bg-mint px-7 py-3.5 text-sm font-semibold text-navy transition-transform hover:-translate-y-0.5">
            Open all calculators <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
        <MiniSip />
      </div>
    </section>
  );
}
